module.exports = __webpack_public_path__ + "media/src/assets/Images/TrashDelete-f581e121142da1559edc02509564d923.svg";